import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PageTemplate.css';

const OlympicAngels = () => {
  const navigate = useNavigate();

  return (
    <div className="page-container">
      <div className="page-content">
        <img src="/assets/olympic-logo.jpg" alt="Olympic Angels by Theo" className="page-logo" />
        <h1>
          Olympic Angels <span className="theo-red">by Theo</span>
        </h1>
        
        <div className="page-text">
          <p>
            Olympic Angels by Theo is a global cultural revival movement – not a pageant – 
            created to restore the ancient Greek ideal of the complete human and to resurrect 
            the founding Olympic traditions that shaped civilization.
          </p>
          
          <p>
            The initiative establishes Olympic-level competition at the local, regional, 
            national, and international levels, culminating each year in Finals in Olympia, 
            Greece, honoring God, virtue, and the timeless values of Magna Graecia.
          </p>
          
          <p>
            A core pillar of the mission is the revival of the Original Olympic Games, led 
            in partnership with the World Chariot Racing Federation (WCRF), to bring back 
            the first and most iconic event of antiquity – Olympic chariot racing. Through 
            this resurrection, Olympic Angels serve as ambassadors of heritage, bridging 
            ancient Olympia with the modern world and reconnecting Greece, the diaspora, 
            and Philhellenes to the True Flame.
          </p>
          
          <p>
            Angel finalists are recognized not for beauty alone but for embodying the Five 
            Divine Human Characteristics that define a complete human being: Body, Mind, 
            Heart, Courage, and Purpose:
          </p>

          <img src="/assets/OlAn.jpg" alt="Five Divine Human Characteristics" className="characteristics-image" style={{ maxWidth: '600px', margin: '20px auto', display: 'block' }} />
          
          <p>
            The mission is to uplift good humans, revive Greece's original Olympic spirit, 
            and inspire the next generation through excellence, education, and the values 
            that built Western civilization.
          </p>
        </div>
      </div>
    </div>
  );
};

export default OlympicAngels;
